<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Registers</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <router-link to="/user_checks">Check Registers</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page" v-if="status">Add Check Register</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update Check Register</li>
                </ol>
                <h4 class="main-title mb-0">Check Register</h4>
            </div>
            <div>
                <router-link to="/user_checks" type="button" class="btn btn-danger me-2"><i class="ri-arrow-left-line fs-18 lh-1"></i> Back</router-link>
                <button type="button" v-if="status" class="btn btn-primary me-2" @click="addUserCheck()"><i class="ri-save-line fs-18 lh-1"></i> Submit</button>
                <button type="button" v-else class="btn btn-primary me-2" @click="updateUserCheck()"><i class="ri-save-line fs-18 lh-1"></i> Update</button>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3" v-can="'check_registers.create'">
                <form>
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Check Register</h6>
                            <h6 class="card-title" v-else>Update Check Register</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-4">
                                    <label class="form-label">Reference Date</label><span class="text-danger"> *</span>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter Reference Date"
                                        :disabled="!status"
                                        :min="status ? minReferenceDate : null"
                                        :class="{'is-invalid': errors?.reference_date}"
                                        v-model="user_check.reference_date"
                                        ref="reference_date"
                                        @change="lockPreviousReferenceDate"
                                    />
                                    <span v-if="errors?.reference_date" class="invalid-feedback">{{ errors?.reference_date[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Asset</label><span class="text-danger"> *</span>
                                    <AssetSearch :disabled="!status" :initialize="user_check.asset_name" @selectAsset="selectAsset($event)" ref="asset_id"></AssetSearch>
                                    <span v-if="errors?.asset_id" class="invalid-feedback">{{ errors?.asset_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Frequency</label><span class="text-danger"> *</span>
                                    <MultiSelect
                                        v-model="user_check.frequencies"
                                        :options="frequencies"
                                        optionLabel="frequency_name"
                                        dataKey="frequency_id"
                                        filter
                                        placeholder="Select Frequency"
                                        :maxSelectedLabels="3"
                                        :class="{ 'p-invalid': errors?.frequencies }"
                                        style="width: 100%; height: 37px;"
                                        @change="onFrequencyChange"
                                        :disabled="!status"
                                    />
                                    <span v-if="errors?.frequencies" class="invalid-feedback">{{ errors?.frequencies[0] }}</span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Note</label>
                                    <textarea type="text" placeholder="Enter Note" class="form-control" :class="{'is-invalid': errors?.note}" v-model="user_check.note"></textarea>
                                    <span v-if="errors?.note" class="invalid-feedback">{{ errors?.note[0] }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Asset Checks</h6>
                    </div>
                    <div class="card-body">
                        <div class="row g-2">
                            <div v-if="user_check.frequencies && user_check.asset_checks" class="table-responsive">
                                <table class="table table-responsive table-striped table-sm text-nowrap table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th>Field name</th>
                                            <th>Field Type</th>
                                            <th>Default Value</th>
                                            <th>Is Required</th>
                                            <th>LCL</th>
                                            <th>UCL</th>
                                            <th>&nbsp;&nbsp;&nbsp;&nbsp;Value&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                             <th>&nbsp;&nbsp;&nbsp;&nbsp;Check Remark&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(frequencyGroup, frequency_id, index) in groupedChecks" :key="frequency_id">
                                            <tr class="frequency-header">
                                                <td colspan="9" class="font-weight-bold">{{ frequencyGroup.frequency_name || 'No Frequency' }}</td>
                                            </tr>
                                            <tr v-for="(check, checkIndex) in frequencyGroup.checks" :key="check.check_id">
                                                <td class="text-center">{{ checkIndex + 1 }}</td>
                                                <td>{{ check.field_name }}</td>
                                                <td>{{ check.field_type }}</td>
                                                <td>{{ check.default_value }}</td>
                                                <td>{{ check.is_required == 1 ? 'Yes' : 'No' }}</td>
                                                <td>{{ check.lcl ?? '' }}</td>
                                                <td>{{ check.ucl ?? '' }}</td>
                                                <td>
                                                    <div>
                                                        <input v-if="check.field_type === 'Text'" type="text" placeholder="Enter Value" class="form-control" v-model="check.value" :class="{'is-invalid': errors[check.field_name]}" />
                                                        <input v-if="check.field_type === 'Number'" type="number" placeholder="Enter Value" class="form-control" v-model="check.value" :class="{'is-invalid': errors[check.field_name]}" />
                                                        <textarea v-if="check.field_type === 'Text Area'" placeholder="Enter Value" class="form-control" v-model="check.value" :class="{'is-invalid': errors[check.field_name]}"></textarea>
                                                        <input v-if="check.field_type === 'Date'" type="date" placeholder="Enter Value" class="form-control" v-model="check.value" :class="{'is-invalid': errors[check.field_name]}" />
                                                        <input
                                                            v-if="check.field_type === 'Date & Time'"
                                                            type="datetime-local"
                                                            placeholder="Enter Value"
                                                            class="form-control"
                                                            :value="formatDateTimeForInput(check.value)"
                                                            @input="check.value = $event.target.value"
                                                            :class="{'is-invalid': errors[check.field_name]}"
                                                        />
                                                        <select v-if="check.field_type === 'Select'" class="form-control" v-model="check.value" :class="{'is-invalid': errors[check.field_name]}">
                                                            <option value="">Select</option>
                                                            <option v-for="(value, key) in check.field_values?.split(',')" :key="key" :value="value">{{ value }}</option>
                                                        </select>
                                                        <span v-if="errors[check.field_name]" class="invalid-feedback">{{ errors[check.field_name][0] }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <textarea placeholder="Enter Check Remark" class="form-control" v-model="check.check_remark" :class="{'is-invalid': errors[check.check_remark]}" style="height: 30px; resize: vertical;"></textarea>
                                                        <span v-if="errors[check.check_remark]" class="invalid-feedback">{{ errors[check.check_remark][0] }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Optional: Show a loading or placeholder message -->
                            <div v-else class="text-center">
                                <p>Loading checks...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AssetSearch from "@/components/AssetSearch.vue";
    import MultiSelect from "primevue/multiselect";
    import moment from "moment";

    export default {
        name: "UserChecks.Create",
        components: { AssetSearch, MultiSelect },
        data() {
            return {
                status: true,
                user_check: {
                    user_check_id: "",
                    frequencies: [],
                    asset_id: "",
                    asset_code: "",
                    asset_name: "",
                    reference_no: "",
                    reference_date: "",
                    note: "",
                    status: "",
                    asset_checks: [],
                    deleted_check_frequencies: [],
                    asset: {}, 
                },
                assets: [],
                asset_checks: [],
                frequencies: [],
                errors: [],
            };
        },
        computed: {
            minReferenceDate() {
                return moment().format("YYYY-MM-DD");
            },
            groupedChecks() {
                const grouped = {};
                if (Array.isArray(this.user_check.frequencies)) {
                    this.user_check.frequencies.forEach((freq) => {
                        grouped[freq.frequency_id] = {
                            frequency_name: freq.frequency_name,
                            checks: [],
                        };
                    });
                }

                grouped["no-frequency"] = {
                    frequency_name: null,
                    checks: [],
                };

                this.user_check.asset_checks.forEach((check) => {
                    const frequency_id = check.frequency_id || "no-frequency";
                    if (grouped[frequency_id]) {
                        grouped[frequency_id].checks.push(check);
                    }
                });

                const sortedGroups = {};
                Object.keys(grouped)
                    .sort((a, b) => {
                        if (a === "no-frequency") return 1;
                        if (b === "no-frequency") return -1;
                        return a - b;
                    })
                    .forEach((key) => {
                        if (grouped[key].checks.length > 0) {
                            sortedGroups[key] = grouped[key];
                        }
                    });

                return sortedGroups;
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (to.name === "UserChecks.Create") {
                    if (vm.$store.getters.asset_id) {
                        vm.user_check.asset_id = vm.$store.getters.asset_id;
                        vm.getAsset();
                        vm.getFrequencies(vm.user_check.asset_id);
                    }
                    vm.$refs.reference_date.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getUserCheck", data: { user_check_id: to.params.user_check_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) 
                        {
                            if (!response || !response.data || !response.data.data) {
                                vm.$store.dispatch("error", "Invalid response from server. Please try again.");
                                console.error("Invalid response:", response);
                                return;
                            }

                            vm.user_check = {
                                ...response.data.data,
                                asset: response.data.data.asset || {},
                                frequencies: [],
                                asset_checks: response.data.data.asset_checks || [],
                            };

                            vm.user_check.asset_id = vm.user_check.asset?.asset_id || "";
                            vm.user_check.asset_code = vm.user_check.asset?.asset_code || "";
                            vm.user_check.asset_name = vm.user_check.asset?.asset_name || "";
                            vm.user_check.reference_date = vm.convertDateFormat(vm.user_check.reference_date);

                            const frequencyMap = {};
                            vm.user_check.asset_checks = (vm.user_check.asset_checks || []).map((check) => {
                                const freq = check.check_frequencies || { frequency_id: null, frequency_name: null };
                                if (freq.frequency_id && !frequencyMap[freq.frequency_id]) {
                                    frequencyMap[freq.frequency_id] = {
                                        frequency_id: freq.frequency_id,
                                        frequency_name: freq.frequency_name,
                                    };
                                }
                                return {
                                    user_asset_check_id: check.user_asset_check_id || null,
                                    check_id: check.check_id || null,
                                    asset_check_id: check.asset_check_id || null,
                                    field_name: check.field_name || "",
                                    field_type: check.field_type || "",
                                    default_value: check.default_value || "",
                                    is_required: check.is_required || 0,
                                    field_values: check.field_values || "",
                                    lcl: check.lcl !== null && check.lcl !== undefined ? check.lcl : null,
                                    ucl: check.ucl !== null && check.ucl !== undefined ? check.ucl : null,
                                    order: check.order ?? 0,
                                    value: check.value || "",
                                    frequency_id: freq.frequency_id || null,
                                    frequency_name: freq.frequency_name || null,
                                    check_remark: check.check_remark || ""
                                };
                            });
                            vm.user_check.frequencies = Object.values(frequencyMap);

                            vm.user_check.asset_checks.sort((a, b) => {
                                if (a.frequency_id === b.frequency_id || (a.frequency_id === null && b.frequency_id === null)) {
                                    return a.order - b.order;
                                }
                                if (a.frequency_id === null) return 1;
                                if (b.frequency_id === null) return -1;
                                return a.frequency_id - b.frequency_id;
                            });

                            vm.getFrequencies(vm.user_check.asset_id);
                            vm.getAssetChecks(
                                vm.user_check.asset_id,
                                vm.user_check.frequencies.map((f) => f.frequency_id).filter((id) => id !== null)
                            );
                        })
                        .catch(function (error) {
                            console.error("Error fetching user check:", error);
                            vm.errors = error.response?.data?.errors ?? "";
                            vm.$store.dispatch("error", error.response?.data?.message ?? "");
                        });
                }
            });
        },
        mounted() {
            if (this.status) {
                this.user_check.reference_date = moment().format("YYYY-MM-DD");
            }
        },
        methods: {
            lockPreviousReferenceDate() {
                if (!this.status) {
                    return;
                }
                if (this.user_check.reference_date && this.user_check.reference_date < this.minReferenceDate) {
                    this.user_check.reference_date = this.minReferenceDate;
                    this.errors = {
                        ...this.errors,
                        reference_date: ["Previous dates are not allowed."],
                    };
                } else if (this.errors?.reference_date) {
                    const { reference_date, ...rest } = this.errors;
                    this.errors = rest;
                }
            },
            getFrequencies(asset_id) {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAssetFrequencies", data: { asset_id: asset_id } })
                    .then((response) => {
                        loader.hide();
                        vm.frequencies = response.data?.data || [];
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? "";
                        vm.$store.dispatch("error", error.response?.data?.message ?? "");
                    });
            },
            getAssetChecks(asset_id, frequency_ids) 
            {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAssetChecks", data: { asset_id: asset_id, frequency_ids: frequency_ids } })
                    .then((response) => {
                        loader.hide();
                        if (response.data?.data?.length) {
                            const existingChecksMap = {};
                            vm.user_check.asset_checks.forEach((check) => {
                                existingChecksMap[check.check_id] = check;
                            });

                            const updatedChecks = response.data.data.map((ele) => {
                                const existingCheck = existingChecksMap[ele.check.check_id];
                                return {
                                    user_asset_check_id: existingCheck ? existingCheck.user_asset_check_id : null,
                                    check_id: ele.check.check_id || null,
                                    default_value: ele.check.default_value || "",
                                    field_name: ele.check.field_name || "",
                                    field_type: ele.check.field_type || "",
                                    field_value: ele.check.field_value || "",
                                    is_required: ele.check.is_required || 0,
                                    field_values: ele.check.field_values || "",
                                    // Preserve LCL/UCL from existing check if it exists, otherwise use from asset check
                                    lcl: existingCheck && (existingCheck.lcl !== null && existingCheck.lcl !== undefined) 
                                        ? existingCheck.lcl 
                                        : (ele.check.lcl !== null && ele.check.lcl !== undefined ? ele.check.lcl : null),
                                    order: existingCheck?.order ?? ele.check?.order ?? ele.order ?? 0,
                                    status: ele.check.status || "",
                                    ucl: existingCheck && (existingCheck.ucl !== null && existingCheck.ucl !== undefined) 
                                        ? existingCheck.ucl 
                                        : (ele.check.ucl !== null && ele.check.ucl !== undefined ? ele.check.ucl : null),
                                    value: existingCheck ? existingCheck.value : "",
                                    asset_check_id: ele.asset_check_id || null,
                                    frequency_id: ele.check.frequency_id || null,
                                    frequency_name: ele.check_frequencies?.frequency_name || null,
                                    check_remark: existingCheck ? existingCheck.check_remark : ele.check.check_remark || "" // Preserve existing check_remark
                                };
                            });

                            const existingNullFrequencyChecks = vm.user_check.asset_checks.filter((check) => check.frequency_id === null);
                            vm.user_check.asset_checks = [...existingNullFrequencyChecks, ...updatedChecks];

                            vm.user_check.asset_checks.sort((a, b) => {
                                if (a.frequency_id === b.frequency_id || (a.frequency_id === null && b.frequency_id === null)) {
                                    return a.order - b.order;
                                }
                                if (a.frequency_id === null) return 1;
                                if (b.frequency_id === null) return -1;
                                return a.frequency_id - b.frequency_id;
                            });
                        }
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? "";
                        vm.$store.dispatch("error", error.response?.data?.message ?? "");
                    });
            },
            addUserCheck() {
                let vm = this;
                let loader = this.$loading.show();
                const errors = {};
                vm.user_check.asset_checks.forEach((check) => {
                    if (check.is_required == 1 && (!check.value || String(check.value).trim() === "")) {
                        errors[check.field_name] = errors[check.field_name] || [];
                        errors[check.field_name].push(`Value is required.`);
                    }
                });
                if (this.user_check.reference_date && this.user_check.reference_date < this.minReferenceDate) {
                    loader.hide();
                    vm.errors = {
                        ...vm.errors,
                        reference_date: ["Previous dates are not allowed."],
                    };
                    vm.$store.dispatch("error", "Previous dates are not allowed.");
                    return;
                }
                if (Object.keys(errors).length > 0) {
                    loader.hide();
                    vm.errors = errors;
                    vm.$store.dispatch("error", "Please add check values before submitting.");
                    return;
                }
                this.$store
                    .dispatch("post", { uri: "addUserCheck", data: vm.user_check })
                    .then((response) => {
                        loader.hide();
                        this.$store.dispatch("success", response.data?.message || "Check register added successfully.");
                        vm.$router.push("/user_checks");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? "";
                        vm.$store.dispatch("error", error.response?.data?.message ?? "");
                    });
            },
            updateUserCheck() {
                let vm = this;
                let loader = this.$loading.show();
                const selectedIds = vm.user_check.frequencies.map((a) => a.frequency_id).filter((id) => id !== null);
                const originalFrequencies = vm.user_check.check_frequencies || [];
                const originalMap = {};
                originalFrequencies.forEach((item) => {
                    if (item.frequency_id) {
                        originalMap[item.frequency_id] = item.frequency_id;
                    }
                });
                const deletedCheckFrequencyIds = Object.keys(originalMap)
                    .map((id) => parseInt(id))
                    .filter((id) => !selectedIds.includes(id));
                vm.user_check.deleted_check_frequencies = deletedCheckFrequencyIds;
                this.$store
                    .dispatch("post", { uri: "updateUserCheck", data: vm.user_check })
                    .then((response) => {
                        loader.hide();
                        this.$store.dispatch("success", response.data?.message || "Check register updated successfully.");
                        vm.$router.push("/user_checks");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? "";
                        vm.$store.dispatch("error", error.response?.data?.message ?? "");
                    });
            },
            getAsset() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAsset", data: { asset_id: vm.user_check.asset_id } })
                    .then((response) => {
                        loader.hide();
                        vm.asset_data = response.data?.data || {};
                        vm.user_check.asset_name = vm.asset_data.asset_name || "";
                        vm.user_check.asset_code = vm.asset_data.asset_code || "";
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? "";
                        vm.$store.dispatch("error", error.response?.data?.message ?? "");
                    });
            },
            convertDateFormat(date) {
                if (!date) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            selectAsset(e) {
                const asset = e.target.value || {};
                this.user_check.asset_name = asset.asset_name || "";
                this.user_check.asset_id = asset.asset_id || "";
                this.user_check.frequencies = [];
                this.user_check.asset_checks = [];
                this.getFrequencies(this.user_check.asset_id);
            },
            onFrequencyChange() {
                const asset_id = this.user_check.asset_id;
                const frequency_ids = this.user_check.frequencies.map((f) => f.frequency_id).filter((id) => id !== null);
                if (asset_id && frequency_ids.length) {
                    this.getAssetChecks(asset_id, frequency_ids);
                } else {
                    this.user_check.asset_checks = this.user_check.asset_checks.filter((check) => check.frequency_id === null);
                }
            },
            formatDateTimeForInput(value) {
                if (!value) return '';
                // Handle different date formats from database
                // Format: "2025-12-25 12:22:00" or "2025-12-25T12:22:00" or ISO format
                if (typeof value === 'string') {
                    // Replace space with T for datetime-local input
                    const formatted = value.replace(' ', 'T');
                    // Remove seconds if present (datetime-local doesn't need seconds)
                    return formatted.substring(0, 16);
                }
                return value;
            },
        },
    };
</script>

<style scoped>
    .frequency-header {
        background-color: #f8f9fa;
        font-weight: bold;
    }
</style>